const Infastructuredata = [
    {
        id : "1",
        schemeName: "Pradhan Mantri Gram Sadak Yojana by Ministry of Rural Development",
        discription:"The Pradhan Mantri Gram Sadak Yojana (PMGSY), was launched by the Govt. of India to provide connectivity to unconnected Habitations as part of a poverty reduction strategy. Govt. of India is endeavoring to set high and uniform technical and management standards and facilitating policy development and planning at State level in order to ensure sustainable management of the rural roads network.",
        launchDate: "25th December, 2000.",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Information on Jawaharlal Nehru National Urban Renewal Mission.",
    discription:"The Jawaharlal Nehru National Urban Renewal Mission (JNNURM), launched on December 3rd 2005 is the largest national urban initiative to encourage reforms and fast track planned development of 63 identified cities. Focus is to be on efficiency in urban infrastructure and service delivery mechanisms, community participation andaccountability of ULB's/Parastatal agencies towards citizens. It consists of two submissions – Urban Infrastructure & Governance, and Basic Services to the Urban Poor ",
    launchDate: "3 December 2005",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Urban Infrastructure Development Scheme for Small and Medium Towns",
    discription:"Urban Renewal is one of the thrust areas in the National Common Minimum Program of the Government and accordingly Jawaharlal Nehru National Urban Renewal Mission (JNNURM) was launched on 3rd December 2005 with an investment of Rs.1,00,000.00 crores in Mission period of seven years beginning 2005-06. Urban Infrastructure Development Scheme for Small an Medium Towns (UIDSSMT) is one of the components of JNNURM. The mission is the single largest initiative of the Government of India for planned development of cities and towns. ",
    launchDate: "3 December 2005",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Programme of Ministry of Housing and Urban Affairs",
        discription:"The Ministry of Housing and Urban Affairs (MoHUA) is a ministry of the Government of India with executive authority over the formulation and administration of the rules and regulations and laws relating to the housing and urban development in India. The ministry was under the charge of Venkaiah Naidu and was given to Hardeep Singh Puri when Naidu was elected Vice President of India. The Ministry became independent from the Ministry of Housing and Urban Poverty Alleviation in 2004,but was later re-merged with it in 2017.", 
        launchDate: "1952; 71 years ago", 
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "V.	National Mission on Manuscripts",
    discription:"Document each and every manuscript and manuscript repository, for a National Electronic Database that currently contains information on four million manuscripts making this the largest database on Indian manuscripts in the world.",
    launchDate: "write", 
     AnualFund: "12345"},
   

 {   id : "6",
    schemeName: "Development of Museum",
    discription:"Digitization of art objects in the museums across the country for making their images/catalogues available over the website",
    launchDate: "write",
    AnualFund: "12345"
},
{   id : "7",
schemeName: "Seva Bhoj Yojana.",
discription:"Seva Bhoj Yojna’ is a Central Sector Scheme of the Ministry of Culture, Government of India.",
launchDate: "1 August 2018",
AnualFund: "12345"},


{   id : "8",
schemeName: "Project Mausam",
discription:"Project ‘Mausam’ is a Ministry of Culture project to be implemented by Indira Gandhi National Centre for the Arts (IGNCA), New Delhi as the nodal coordinating agency with support of Archeological Survey of India and National Museum as associate bodies.",
launchDate: "20 June 2014",
AnualFund: "12345"},


{   id : "9",
schemeName: "Scheme For Pension And Medical Aid to Artistes",
discription:"‘A pension scheme by MoC improving the financial and socio-economic status of the old artists and scholars who have contributed significantly in their specialized fields, but due to old age they have to lead a miserable life or are in penury condition",
launchDate: " 3 January 2018",
AnualFund: "12345"},

]

export default Infastructuredata;